export default __webpack_public_path__ + "static/media/step12.3ef17401.svg";